import { Component, Input } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order, OrdersService } from 'src/app/core/orders.service';
import { ERROR_ORDER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-store-details-order-data',
  templateUrl: './store-details-order-data.component.html',
  styleUrls: ['./store-details-order-data.component.scss'],
})
export class StoreDetailsOrderDataComponent {
  @Input() store_id?: string | null;
  orders?: Order[];
  is_read_running = true;

  constructor(private orders_service: OrdersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.orders = [];
    if (this.store_id) this.listOrders(this.store_id);
  }

  onRefresh(): void {
    this.orders = [];
    if (this.store_id) this.listOrders(this.store_id);
  }

  listOrders(store_id?: string): void {
    this.is_read_running = true;

    if (store_id) {
      this.orders_service.listByStoreID(store_id).subscribe({
        next: response => {
          this.orders = response.data;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_ORDER_NOT_FOUND) {
            this.orders = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
